import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { MediaReducer } from '@synergy/data-access';
import { combineReducers } from 'redux';

import { AppState } from './store/models/app-state';
import { bonusSettlementsReducer } from './features/bonus-settlements/store/bonus-settlements-reducer';
import { currentAccountBonusReducer } from './common/reducers/current-account-bonus-reducer';
import { currentAccountReducer } from './common/reducers/current-account-reducer';
import { customerReducer } from './common/reducers/customer-reducers';
import { inquiriesReducer } from './features/inquiry/reducers/inquiry-reducers';
import { lastCheckedDateReducer } from './common/reducers/last-checked-date-reducer';
import { localeReducer } from './common/reducers/locale-reducer';
import { notificationsReducer } from './common/reducers/notifications-reducers';
import { offersReducer } from './features/offers/reducer/offers-reducer';
import { positionsReducer } from './common/reducers/positions-reducer';
import { purchaseOrdersReducer } from './features/purchases-orders/reducers/purchase-orders-reducer';
import { settingsReducer } from './common/reducers/settings-reducer';
import { userManagementReducer } from './features/user-management/reducers/user-management-reducers';
import { userReducer } from './common/reducers/user-reducer';

export const rootReducer = combineReducers<AppState>({
    media: MediaReducer,
    settings: settingsReducer,
    offers: offersReducer,
    locale: localeReducer,
    user: userReducer,
    currentAccount: currentAccountReducer,
    currentAccountBonus: currentAccountBonusReducer,
    customers: customerReducer,
    userManagement: userManagementReducer,
    lastCheckedDate: lastCheckedDateReducer,
    inquiryData: inquiriesReducer,
    purchaseOrderData: purchaseOrdersReducer,
    lastCheckedExpirationThresholdInDays: lastCheckedDateReducer,
    notifications: notificationsReducer,
    positions: positionsReducer,
    bonusSettlements: bonusSettlementsReducer,
    [Snackbar.name]: Snackbar.reducer,
});
